import { useEffect, useState } from "react";
import TabButton from "../atoms/TabButton";
import Tab from "./Tab";

export default function TabSwitcher({list, modifier='', customClass=''}) {
    const [activeTab, setActiveTab] = useState(0);
    const [tabList, setTabList] = useState([]);
    const moduleName = 'tab-switcher';
    const modifierClass = modifier ? `${moduleName}--${modifier}` : '';
    const customCSSClass = customClass ? customClass : '';

    useEffect(()=> {
        setActiveTab(0);
    }, [])

    useEffect(() => {
        setTabList(list);
    }, [list])

    const handleChange = (value) => {        
        setActiveTab(parseInt(value));
    }

    return (
        <div className={ `tab-switcher ${modifierClass} ${customCSSClass}` }>
            <nav className="tab-nav tab-nav--fixed">

                { Object.keys(tabList).map(key => (
                    <TabButton 
                        index={key} 
                        handleChange={handleChange} 
                        initialChecked={activeTab === parseInt(key)} 
                        active={activeTab === parseInt(key)} 
                        title={tabList[key].title}
                        icon={tabList[key].icon}
                        key={key}
                    >
                        {tabList[key].title}
                    </TabButton>
                ))}
            </nav>

            <div className={`${moduleName}__tabs`}>
                { Object.keys(tabList).map(key => (
                    <Tab 
                        index={key} 
                        show={activeTab === parseInt(key)}
                        customClass={modifier}
                        key={key}
                    >
                        {tabList[key].component}
                    </Tab>
                ))}
            </div>
        </div>
    );
}